import { TraceRendererOptions, TraceRenderStrategy } from "./RenderStrategy"
import { LineRenderStrategy } from "./D3LineRenderStrategy"
import { seriesCanvasPoint } from "d3fc"
import { TimeSeriesData } from "../../../../Data/TimeSeriesData"
import { ModalityPage } from "../../../../Data/ModalityPage"

export class PointRenderStrategy extends LineRenderStrategy implements TraceRenderStrategy {
    protected setupRenderers() {
        this.directRenderer = seriesCanvasPoint()
        this.offscreenRenderer = seriesCanvasPoint()
    }

    public getDirectRenderer = (options?: TraceRendererOptions) => {
        if (options?.xScale) {
            this.directRenderer.xScale(options.xScale)
        }

        if (options?.yScale) {
            this.directRenderer.yScale(options.yScale)
        }

        return this.directRenderer
            .mainValue((p: [number, number]) => p[1])
            .crossValue((p: [number, number]) => p[0])
            .size(16)
            .decorate((context: CanvasRenderingContext2D) => {
                context.strokeStyle = this.config.color
                context.fillStyle = this.config.color
            })
    }

    public getOffscreenRenderer = (options?: TraceRendererOptions) => {
        if (options?.xScale) {
            this.offscreenRenderer.xScale(options.xScale)
        }

        if (options?.yScale) {
            this.offscreenRenderer.yScale(options.yScale)
        }

        return this.offscreenRenderer
            .mainValue((p: [number, number]) => p[1])
            .crossValue((p: [number, number]) => p[0])
            .size(16)
            .decorate((context: CanvasRenderingContext2D) => {
                context.strokeStyle = this.config.color
                context.fillStyle = this.config.color
            })
    }

    public renderTimeSeriesData(data: TimeSeriesData, page: ModalityPage, renderer: (drawableData: Iterable<[(number | undefined), (number | undefined)]>) => void) {
		const drawableData = [...this.drawableDataGenerator(data, page)]
		renderer(drawableData)

		// The edges can be used to redraw the gap between pages when the underlying data is unavailable
		const edges = [
			[data.times[0], data.data[0]], 
			[data.times[data.times.length - 1], data.data[data.data.length - 1]]
		]

		return edges as [number | undefined, number][]
	}
}
